import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@src/store';
import { agentActions } from '@src/store/reducers/agentReducer';
import { cloneDeep } from 'lodash';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { DialogManagerService } from '@src/services';
import { jobsActions } from '@src/store/reducers/jobsReducer';

@Component({
    selector: 'agents',
    template: require('./agents.component.html'),
    styles: [require('./agents.component.scss')]
})
export class AgentsComponent implements OnInit, OnDestroy {

    public selectedAgent: any = {};
    public selectedCluster: any = {};
    public clusters: any[] = [];
    public isJobWaiting = true;
    public agents: any;
    private indexInList: number = 0;
    private tempAgent: any = {};
    private interval: any;
    public translations;
    public runningProcesses: any = [];
    private isPanelOpened: boolean = false;

    constructor(private store: Store,
                private translatePipe: TranslatePipe,
                private dialogManagerService: DialogManagerService,
                @Inject('processDetailsModalService') private processDetailsModalService: any) {
    }

    public async ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR', 'SUCCESS_JOB_KILL', 'FAIL_JOB_KILL',
            'CANCEL_JOB', 'ABORT_JOB']).then(value => this.translations = value);
        this.clusters = await this.store.dispatch({ type: agentActions.GET_CLUSTER_WITH_AGENT });
        this.store.dispatch({ type: agentActions.GET_AGENTS })
            .then((data: any) => {
                this.agents = data;
            });
        this.autoRefreshParameters();
    }

    public ngOnDestroy(): void {
        clearInterval(this.interval);
    }

    private autoRefreshParameters(): void {
        this.interval = setInterval(() => {
            if (!this.selectedAgent || !this.selectedAgent.ID) {
                return;
            }
            if (this.isPanelOpened) {
                this.getJobExecuting();
            }
            this.store.dispatch({
                type: agentActions.GET_AGENT_STATUS,
                payload: { agentId: this.selectedAgent.ID }
            }).then(agentStatus => this.selectedAgent.AgentStatus = agentStatus);
        }, 15000);
    }

    private getJobExecuting(): void {
        this.store.dispatch({
            type: agentActions.GET_AGENT_JOBS_EXECUTING,
            payload: { agentId: this.selectedAgent.ID }
        }).then(runingJobs => this.runningProcesses = runingJobs);
    }

    public getAgent(selectedItem: any, indexInList: any): void {
        this.selectedAgent = selectedItem;
        this.tempAgent = cloneDeep(this.selectedAgent);
        this.selectedCluster = this.clusters.find(el => el.ID === this.selectedAgent.ClusterId);
        this.indexInList = indexInList;
        this.getJobExecuting();
    }

    public save(): void {
        this.store.dispatch({
            type: agentActions.UPDATE_AGENT,
            payload: { agent: this.selectedAgent }
        }).then((data: any) => {
            if (data) {
                this.tempAgent = cloneDeep(this.selectedAgent);
                this.agents[this.indexInList] = this.selectedAgent;
                this.dialogManagerService.showSuccessDialog({ title: '', text: '' });
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['UNEXPECTED_ERROR']
                });
            }
        });
    }

    public cancel(): void {
        this.selectedAgent = cloneDeep(this.tempAgent);
    }

    public clusterChange(): void {
        this.selectedAgent.ClusterId = this.selectedCluster.ID;
    }

    public restart(): void {
        this.store.dispatch({
            type: agentActions.RESTART_AGENT,
            payload: { agentId: this.selectedAgent.ID, waitForJobs: this.isJobWaiting }
        }).then((data: any) => {
            if (data) {
                this.selectedAgent.AgentStatus = 1;
                this.tempAgent = cloneDeep(this.selectedAgent);
                this.dialogManagerService.showSuccessDialog({ title: 'Success - Restart Agent', text: '' });
            } else {
                this.dialogManagerService.showErrorDialog({
                    title: this.translations['ERROR'],
                    text: this.translations['UNEXPECTED_ERROR']
                });
            }
        });
    }

    public isDisabled(): boolean {
        return !this.agents || this.agents.length === 0;
    }

    public agentJobsOpen() {
        this.isPanelOpened = true;
        this.getJobExecuting();
    }

    public agentJobsClose() {
        this.isPanelOpened = false;
    }

    public openDetails(runningProces: any) {
        this.processDetailsModalService.OpenProcessDetailsModal(runningProces);
    }

    private customJobKillResponseHandling(resp, process, type: string) {
        let modalData;
        const actionType = type === 'Cancel' ? 'Cancelling' : `${type}ing`;
        if (resp.data && resp.data === true) {
            modalData = {
                message: this.translations['SUCCESS_JOB_KILL']
                    .replace('%s1', process.JobQId)
                    .replace('%s2', `${process.Title} ${process.VersionNames ? ` - ${process.VersionNames}` : ''}`)
                    .replace('%s3', process.EnvironmentNames).replace('%s4', actionType),
                text: ''
            };
            this.getJobExecuting();
            this.dialogManagerService.showSuccessDialog({ title: modalData.message, text: modalData.text });
        } else {
            modalData = {
                message: this.translations['FAIL_JOB_KILL']
                    .replace('%s1', process.JobQId)
                    .replace('%s2', `${process.Title} ${process.VersionNames ? ` - ${process.VersionNames}` : ''}`)
                    .replace('%s3', process.EnvironmentNames).replace('%s4', actionType),
                text: ''
            };
            this.dialogManagerService.showErrorDialog({ title: modalData.message, text: modalData.text });
        }
    }

    public killJob(process): void {
        const onConfirm = () => {
            const type = process.Status === 0 ? this.translations['CANCEL_JOB'] : this.translations['ABORT_JOB'];
            return this.store.dispatch({
                type: jobsActions.KILL_JOB,
                payload: { jobQId: process.JobQId, actionType: type },
                customErrorHandling: false,
                silentRequest: false
            }).then(resp => this.customJobKillResponseHandling(resp, process, type));
        };
        const dialogData = { title: process.Status === 0 ? 'Cancel Job' : 'Abort Job', action: process.Status === 0 ?
                'cancel' : 'abort' , item: process.Title };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/admin/agents/agents.component.ts